import { Trans, useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, ButtonBar, Text, TextLink, Tray } from '@frontend/design-system';
import { AudienceTray } from '../audience-tray/audience-tray';
import { useAudienceTray } from '../providers/audience-tray-provider';

export const PrivacyView = () => {
  const { t } = useTranslation('bulk-messaging');
  const { setMode, trackingIdPrefix } = useAudienceTray();

  return (
    <>
      <AudienceTray.Header title={t('Privacy Rules')} onBackClick={() => setMode('filters')} />
      <Tray.Body
        css={{
          padding: theme.spacing(2, 4),
        }}
      >
        <Text
          css={{
            color: theme.colors.neutral50,
          }}
        >
          <Trans t={t}>
            Please note: The HIPAA Privacy Rule requires an individual's written authorization before their PHI can be
            used for marketing. Compliance with the Privacy Rule while using Weave's Bulk Messaging feature will depend
            on the content of the text and other factors. You can learn more about HIPAA and marketing by visiting the{' '}
            <TextLink
              to='https://www.hhs.gov/hipaa/for-professionals/privacy/guidance/marketing/index.html'
              target='_blank'
              trackingId={`${trackingIdPrefix}-privacy-rules-website-link`}
            >
              HHS website
            </TextLink>
            .
          </Trans>
        </Text>
      </Tray.Body>
      <AudienceTray.Footer hideBorder>
        <AudienceTray.Footer.ActionsBar>
          <ButtonBar css={{ justifyContent: 'flex-end', padding: 0 }}>
            <Button
              onClick={() => setMode('filters')}
              size='large'
              trackingId={`${trackingIdPrefix}-privacy-rules-filter-back-btn`}
              variant='secondary'
            >
              {t('Back')}
            </Button>
          </ButtonBar>
        </AudienceTray.Footer.ActionsBar>
      </AudienceTray.Footer>
    </>
  );
};
